import Vue from 'vue';
import HmacSHA256 from 'crypto-js/hmac-sha256';
import Base64 from 'crypto-js/enc-base64';
import utils from './tools';
import toast from './toast';
import { env } from './dev';

// 鉴权的配置
const authConfig = {
  'pdv-h5': {
    access_key: 'D7d1od6OjcuUm6vz',
    secret_key: 'CQMDcCuPfPZTbmH4vHgLaMsvkk382Hxd',
    version: '1.0.0',
    platform: 3,
  },
  wwx: {
    access_key: 'DF93klyLb8kOKgHK',
    secret_key: 'OD4wVyYHs9lQHHORwr9s3feuLQAczfjF',
    version: '1.0.0',
    platform: 11,
  },
};

let commonHeaders = {};

export default {
  setCommonHeader(headers) {
    commonHeaders = headers;
  },
  // 底层请求
  request(method, url, data, options) {
    return new Promise((resolve, reject) => {
      options = options || {};
      options.timeout = options.timeout || 30000;

      const fullUrl = url.indexOf('http') > -1 ? url : options.baseURL + url;

      // 发送请求
      Vue.http[method](fullUrl, data, {
        headers: options.headers,
        timeout: options.timeout,
      }).then(
        (res) => {
          // 如果不解析，直接返回，
          if (options.notParse) {
            resolve(res);
            return;
          }
          if (!res || !res.data) {
            if (!options.noToast) toast.show('请求出错，请稍后再试');

            return reject('请求出错，请稍后再试');
          }

          const data = res.data;

          if (data.ret !== 0) {
            if (!options.noToast) toast.show(data.msg);
            return reject(data);
          }

          resolve(data.body || data);
        },
        (err) => {
          if (!options.noToast) toast.show('请求失败');
          reject(err);
        },
      );
    });
  },
  newPost(url, data, options) {
    const finalOptions = Object.assign(
      {},
      {
        notParse: false,
        noToast: false,
        baseURL: utils.urlBase,
        headers: this.getHttpAuthHeader(),
      },
      options || {},
    );
    return this.request('post', url, data, finalOptions);
  },
  post(url, data, options) {
    const finalOptions = Object.assign(
      {},
      {
        notParse: true, // 默认不解析，因为老代码都在页面内自己解析了
        noToast: true, // 默认页不显示toast，因为老代码都在页面自己报错了
        baseURL: utils.urlBase,
        headers: this.getHttpAuthHeader(),
      },
      options || {},
    );
    return this.request('post', url, data, finalOptions);
  },

  wwxPost(url, data, options = {}) {
    const finalOptions = Object.assign(
      {},
      {
        notParse: true, // 默认不解析，因为老代码都在页面内自己解析了
        noToast: true, // 默认页不显示toast，因为老代码都在页面自己报错了
        baseURL: env.apiBase,
        headers: Object.assign(
          {},
          commonHeaders,
          this.getHttpAuthHeader({ type: 'wwx', token: commonHeaders.token }),
        ),
      },
      options || {},
    );
    return this.request('post', url, data, finalOptions);
  },

  // 获取http授权头
  getHttpAuthHeader(options) {
    const finnalOptions = Object.assign(
      {},
      {
        type: 'pdv-h5',
        token: '',
      },
      options,
    );
    const currnetAuthConfig = authConfig[finnalOptions.type];
    const RequestId = utils.ranString(32);
    const gmtDateStr = new Date().toGMTString();

    const str = `${currnetAuthConfig.access_key}\n${gmtDateStr}\n${currnetAuthConfig.version}\n${RequestId}`;

    const auth = Base64.stringify(
      HmacSHA256(str, currnetAuthConfig.secret_key),
    );

    const headers = {
      'X-Version': currnetAuthConfig.version,
      'X-Date': gmtDateStr,
      'X-Request-Id': RequestId,
      Authorization: `Basic ${auth}`,
      platform: `${currnetAuthConfig.platform}`,
    };
    if (finnalOptions.token) {
      headers['X-Token'] = finnalOptions.token;
    }
    return headers;
  },
};
